export const beforeAfterProjects = [
  {
    id: "roof-restoration",
    title: "Roof restoration transformation",
    description:
      "A worn roof surface can become a cleaner, longer-lasting system with the right replacement plan and installation quality.",
    beforeImage:
      "https://images.unsplash.com/photo-1646641695635-690b0d0f5bf6?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85",
    afterImage:
      "https://images.unsplash.com/photo-1713526693143-0428aa3ae270?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "repair-rebuild",
    title: "Repair-ready to professionally restored",
    description:
      "From exposed problem areas to a professionally coordinated repair, Monarch focuses on durable fixes rather than quick patches.",
    beforeImage:
      "https://images.pexels.com/photos/12243107/pexels-photo-12243107.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    afterImage:
      "https://images.pexels.com/photos/15964928/pexels-photo-15964928.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "los-angeles-upgrade",
    title: "Los Angeles home efficiency upgrade",
    description:
      "A local property can move from a standard exterior setup to a cleaner, solar-ready roof designed for better performance and curb appeal.",
    beforeImage:
      "https://images.pexels.com/photos/36241381/pexels-photo-36241381.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    afterImage:
      "https://images.pexels.com/photos/12284244/pexels-photo-12284244.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const losAngelesAreas = [
  "Downtown Los Angeles",
  "Hollywood",
  "West Hollywood",
  "Pasadena",
  "Burbank",
  "Santa Clarita",
  "Encino",
  "Monrovia",
];

export const roofingCategories = [
  {
    id: "roof-installation-replacement",
    eyebrow: "Roof Installation & Replacement",
    title: "New roof installation & full replacement",
    description:
      "We specialize in installing premium roofing systems for residential and commercial properties. Whether you're building a new home or replacing an aging roof, we provide expert craftsmanship using top-grade materials to ensure long-term durability, energy efficiency, and curb appeal.",
    imageUrl:
      "https://images.pexels.com/photos/34304714/pexels-photo-34304714.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    highlights: [
      "Asphalt shingles, tile, and metal roofing",
      "Energy-efficient roofing systems",
      "Long-lasting weather protection",
      "Clean, professional installation",
    ],
  },
  {
    id: "roof-repair-services",
    eyebrow: "Roof Repair Services",
    title: "Reliable roof repair & leak fixing",
    description:
      "From minor leaks to major storm damage, our repair services are designed to restore the integrity of your roof quickly and effectively. We identify the root cause and provide lasting solutions—not temporary fixes.",
    imageUrl:
      "https://images.pexels.com/photos/12243107/pexels-photo-12243107.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    highlights: [
      "Leak detection and repair",
      "Storm and wind damage restoration",
      "Emergency repair services",
      "Cost-effective solutions",
    ],
  },
  {
    id: "roof-inspection-maintenance",
    eyebrow: "Roof Inspection & Maintenance",
    title: "Comprehensive roof inspections & preventative maintenance",
    description:
      "Regular inspections help prevent costly repairs and extend the lifespan of your roof. Our detailed assessments identify hidden issues before they become major problems, ensuring your property remains protected year-round.",
    imageUrl:
      "https://images.pexels.com/photos/28812507/pexels-photo-28812507.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    highlights: [
      "Full roof condition reports",
      "Preventative maintenance plans",
      "Insurance inspection support",
      "Early damage detection",
    ],
  },
  {
    id: "roofing-materials-systems",
    eyebrow: "Roofing Materials & Systems",
    title: "High-quality roofing materials for every property",
    description:
      "We work with a wide range of roofing materials to match your style, budget, and performance needs. Our team helps you choose the best option for durability, efficiency, and aesthetics.",
    imageUrl:
      "https://images.pexels.com/photos/31771167/pexels-photo-31771167.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    highlights: [
      "Asphalt shingles (affordable & versatile)",
      "Tile roofing (durable & stylish)",
      "Metal roofing (modern & energy-efficient)",
      "Flat roofing systems (commercial-grade)",
    ],
  },
  {
    id: "storm-damage-insurance-claims",
    eyebrow: "Storm Damage & Insurance Claims",
    title: "Storm damage repair & insurance assistance",
    description:
      "Severe weather can cause unexpected roof damage. We help homeowners navigate insurance claims while restoring roofs quickly and professionally.",
    imageUrl:
      "https://images.pexels.com/photos/6338827/pexels-photo-6338827.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    highlights: [
      "Storm damage assessment",
      "Insurance claim assistance",
      "Fast repair turnaround",
      "Emergency tarping services",
    ],
  },
];

export const roofingTrustPoints = [
  "Licensed and insured professionals",
  "High-quality materials and workmanship",
  "Transparent pricing and honest recommendations",
  "Fast turnaround with minimal disruption",
  "Customer satisfaction guaranteed",
];